export default "__VITE_ASSET__BcGRO27v__"